import Cookies from "js-cookie";
import { useEffect, useState } from "react";

const useCheckLimit = () => {
	const [limit, setLimit] = useState(100);

	let limitCount = parseInt(Cookies.get("genCount"));

	//Increase Limiter if accessed from Dashboard
	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const idParam = urlParams.get("id");

		if (idParam) {
			const timestamp = parseInt(idParam.slice(4)); // remove first 4 digits
			const currentTimestamp = Math.floor(Date.now() / 1000); // get current UNIX timestamp

			// calculate the difference in minutes
			const diffInMinutes = Math.abs(currentTimestamp - timestamp) / 60;

			if (diffInMinutes <= 60) {
				setLimit(100);
			} else {
				setLimit(15);
			}
		} else {
			setLimit(15);
		}
	}, []);

	if (limitCount > limit) return true;
	return false;
};

export default useCheckLimit;
